<template>
    <v-app light>
        <v-toolbar class="white"  app>
              <v-toolbar-title >
                <img  style="vertical-align:middle !important;" src="assets/sicomcitybosspage.png" alt="Vuetify.js" height="50" >
              </v-toolbar-title>
              <v-spacer></v-spacer>

        <!--   <v-btn flat color="primary" href="#Inicio">Inicio</v-btn>
          <v-btn flat color="primary" href=#Modulos>Modulos</v-btn>
          <v-btn flat color="primary" href="#Beneficios">Beneficios</v-btn> -->
          <v-btn  color="primary" text flat href="http://sicom.cl/index.php/contacto/">Contacto</v-btn> 
        </v-toolbar>

        <!-- Plantilla celular  -->
            <template v-if="$vuetify.breakpoint.smAndDown">
                <v-container fluid>
                    <v-layout align-space-between align-center  justify-center column pt-4 >
                        <v-card-title class="px-0 pb-0 pt-5 ">
                                <p style="font-size:20px; font-weight:300; font-family:Calibri;color:rgb(41,44,50);margin-bottom: 0px !important;">
                                    CityBoss<span v-if="getMobileOperatingSystem==='iOS'" style="font-size:75%; font-family:Calibri;vertical-align:middle;">&#9415</span>
                                    <span v-if="getMobileOperatingSystem==='Android'" style="font-size:20px; font-family:Calibri;vertical-align:middle;">&#xAE</span>
                                </p>
                        </v-card-title>
                        <v-flex  align-self-center >
                            <v-card-text class="px-0 pt-0 pb-2">
                                <p  style=" font-family: 'Calibri'; font-weight:500; font-size:13px; color:rgb(130,130,130);text-align:center;">Aplicación para teléfonos móviles que permite<br> comunicar a ciudadanos con municipalidades.</br>
                                </p>
                            </v-card-text>
                        </v-flex>
                        <v-spacer></v-spacer>                        
                        <v-flex shrink>
                            <v-layout justify-center style="height: 90vw">
                                <v-flex align-self-center shrink>
                                    <v-btn  style= "max-width:65px;"
                                            class="btn-stepper-back-phone "
                                            color="white"
                                            @click="btnBack()"
                                        >
                                        <svg style="width:25px; height:25px" viewBox="0 0 24 24">
                                            <path fill="#68b7f6" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                                        </svg>
                                    </v-btn> 
                                </v-flex>
                                <v-flex shrink>
                                    <v-layout  style="position: relative; height: 95vw; width: 60vw">
                                        <v-flex style="position: absolute; top: 2px; bottom: 0px; left: 2px; right: 0px">
                                            <v-carousel
                                                class="carousel-phone"
                                                hide-delimiters
                                                hide-controls
                                                :cycle="false"
                                                v-model="tab"
                                                style="margin-left: 10vw; margin-top: 4.6vw; align-content: center">
                                                <v-carousel-item 
                                                    v-for="(item,i) in items"
                                                    :key="i"
                                                    :src="item.src"
                                                ></v-carousel-item>
                                            </v-carousel>
                                        </v-flex>
                                        <v-flex   style="position: absolute; pointer-events:none;">
                                            <v-img  contain style="position: absolute; top:0px; height:97.5vw !important; width: 60vw !important" src="assets/iphone_mockup.png"></v-img>
                                        </v-flex>
                                    </v-layout> 
                                </v-flex>
                                <v-flex align-self-center shrink >
                                    <v-btn  style= "max-width:65px;"
                                            class="btn-stepper-next-phone"
                                            color="white"
                                            @click="btnNext()">
                                        <svg style="width:25px; height:25px" viewBox="0 0 24 24">
                                            <path fill="#68b7f6" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                                        </svg>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex shrink pt-0>
                            <v-radio-group hide-details class="radio-group-phone" style="justify-content: center;" v-model="tab"  row>
                                <v-radio :ripple="false" class="radio-phone" on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="0"></v-radio>
                                <v-radio :ripple="false" class="radio-phone" on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="1"></v-radio>
                                <v-radio :ripple="false" class="radio-phone" on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="2"></v-radio>
                                <v-radio :ripple="false" class="radio-phone" on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="3"></v-radio>
                                <v-radio :ripple="false" class="radio-phone" on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="4"></v-radio>
                            </v-radio-group> 
                        </v-flex>
                    </v-layout>
                    <v-layout align-center justify-center column pt-3>
                       <a class="text-capitalize" :style="'color: #68b7f6;font-weight: 500;font-size:20px;font-family:Calibri;'">
                       {{['Incidencias', 'Denuncias', 'Encuentas', 'Avisos', 'Contactos'][tab]}}</a>

                        <v-card-text class="px-0 pt-1">
                           <p style="font-weight:300;font-size:13px;color:rgb(130,130,130);font-family:'Calibri Light';text-align:center; ">{{ tabItems[tab] }}</p>
                        </v-card-text>
                     </v-layout>
                    <v-layout align-center justify-center pb-5>   
                        <v-flex shrink px-3 v-if="getMobileOperatingSystem === 'iOS'">
                            <a target="_blank" href="https://apps.apple.com/cl/app/cityboss/id1453082480">
                                <img  height="" width="97" src="assets/store-apple-download-hd.png"></img> 
                            </a>            
                        </v-flex> 
                        <v-flex shrink px-3 v-if="getMobileOperatingSystem === 'Android'">
                            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.sicomelectronics.cityboss">
                                <img width="96" src="assets/app-google-play-hd.png"></img>
                            </a>            
                       </v-flex>  
                    </v-layout>
                            
                    </v-container>
                            <v-footer class="container-footer" dark flex>
                                <v-layout pb-2 justify-center align-center row wrap class="footer">
                                    <v-flex class="footer-copyright" style="font-size:12px">
                                        Copyright &copy; 2019
                                        <a
                                            href="http://sicomelectronics.com"
                                            target="_blank"
                                            style="color: white; text-decoration: none;font-size:12px"
                                        >Sicom Electronics International S.A.</a>
                                     </v-flex>
                                </v-layout>
                            </v-footer>
            </template>


<!--Plantilla  tamaño normal  -->
        <template v-else >
            <v-content>
                <section id=Modulo>
                     <v-container fluid pa-5 mx-0>
                        <v-layout row wrap py-2 pr-0 justify-space-around>
                            <v-flex md5 sm12 xs12 px-5 pb-5 >
                                <v-card-title class="px-0 pb-0">
                                   <p style="font-size:64px; font-weight:300; font-family: Calibri;color:rgb(41,44,50)">
                                      CityBoss<span style="font-size:75%; font-family: Calibri; vertical-align:middle">&#9415</span>
                                    </p>
                                </v-card-title>
                                <v-card-text class="px-0 pt-0 pb-4">
                                 <p style=" font-family: 'Calibri'; font-weight:500; font-size:22px; color:rgb(130,130,130)">Aplicación para teléfonos móviles que permite<br> comunicar a ciudadanos con municipalidades.</br>
                                  </p>
                                </v-card-text>
                                  
                                <v-spacer></v-spacer>
                               

                                <v-tabs 
                                    style=""
                                    v-model="tab"
                                    text>
                                    <v-tabs-slider  color="#68b7f6"></v-tabs-slider>


                                    <v-tab  :ripple="false" style="margin-right: 15px;color: #68b7f6 !important;   "> 
                                       <a class="text-capitalize" :style="(tab === 0 ? 'color: #68b7f6;' : 'color: rgb(124,124,124);') +'font-weight: 500;font-size:24px;font-family:Calibri;'">Incidencias</a>
                                        
                                    </v-tab>

                                     <v-tab :ripple="false" style="margin-right: 15px;">
                                      <a  class="text-capitalize" :style="(tab === 1 ? 'color: #68b7f6;' : 'color: rgb(124,124,124);') +'font-weight: 400;font-size:24px;font-family:Calibri ;'" >Denuncias</a>
                                        
                                    </v-tab>

                                    <v-tab  :ripple="false" style="margin-right: 15px;">
                                        <a  class="text-capitalize" :style="(tab === 2 ? 'color: #68b7f6;' : 'color: rgb(124,124,124);;') +'font-weight: 400;font-size:24px;font-family:Calibri ;'">Encuentas</a>
                                       
                                    </v-tab>

                                    <v-tab :ripple="false" style="margin-right: 15px;">
                                        <a  class="text-capitalize" :style="(tab === 3 ? 'color: #68b7f6;' : 'color: rgb(124,124,124);') +'font-weight: 400;font-size:24px;;font-family:Calibri ;'">Avisos</a>
                                       
                                    </v-tab>

                                    <v-tab :ripple="false" style="margin-right: 15px;">
                                       <a  class="text-capitalize" :style="(tab === 4 ? 'color: #68b7f6;' : 'color: rgb(124,124,124);') +'font-weight: 400;font-size:24px;font-family:Calibri ;'">Contactos</a>
                                        
                                    </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="tab" style="min-height:250px;margin-top:50px; text-align: justify; text-justify: inter-word;">
                                    <v-tab-item
                                        v-for="(value, index) in tabItems"
                                        :key="index"
                                        ><v-card flat>
                                            <v-card-text class="px-0">
                                               <p style="font-weight:300;font-size:22px;color:rgb(130,130,130);font-family:'Calibri Light';">{{ value }}</p>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs-items>
                                <v-layout align-start pt-0>
                                    <v-flex align-self-end  pr-4 shrink>
                                        <a target="_blank" href="https://apps.apple.com/cl/app/cityboss/id1453082480">
                                            <img   width="150" src="assets/store-apple-download-hd.png"></img> 
                                        </a>            
                                    </v-flex> 
                                    <v-flex>
                                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.sicomelectronics.cityboss">
                                            <img width="151" src="assets/app-google-play-hd.png"></img>
                                        </a>            
                                    </v-flex>  
                                </v-layout>      
                            </v-flex>
                            <v-flex pl-5 md5 sm12 xs12>
                              <v-layout row justify-center>
                                <v-flex align-self-center shrink>
                                    <v-btn  style= "max-width: 65px"
                                            class="btn-stepper-back"
                                            color="white"
                                            @click="btnBack()"
                                    ><svg style="width: 40px; height: 40px" viewBox="0 0 24 24">
                                    <path fill="#68b7f6" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                                    </svg>
                                    </v-btn> 
                                </v-flex>
                                <v-flex shrink>
                                  <v-layout column wrap style="width: 400px">
                                    <v-flex style="position: relative;">
                                        <v-carousel
                                            hide-delimiters
                                            hide-controls
                                        :cycle="false" v-model="tab" height="820"  style="margin-left: 51px; padding-top:2%;  align-content:center;border-radius:7px;  ">
                                            <v-carousel-item 
                                                v-for="(item,i) in items"
                                                :key="i"
                                                :src="item.src"
                                            ></v-carousel-item>
                                        </v-carousel>
                                        
                                        <v-img style="position: absolute;top:0px; height:700px !important;" width="400" src="assets/iphone_mockup.png"></v-img>  
                                       

                                    </v-flex>
                                    <v-layout row wrap>
                                        <v-flex>
                                              <v-radio-group  style="justify-content: center;margin-left:10px;" v-model="tab"  row>
                                                     <v-radio on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="0"></v-radio>
                                                     <v-radio on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="1"></v-radio>
                                                     <v-radio on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="2"></v-radio>
                                                     <v-radio on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="3"></v-radio>
                                                     <v-radio on-icon="mdi-circle" off-icon="mdi-circle-outline" color=rgb(104,183,246) :value="4"></v-radio>
                                                </v-radio-group> 
                                        </v-flex>
                                    </v-layout>
                                  </v-layout>
                                </v-flex> 
                                <v-flex shrink align-self-center>
                                    <v-btn  style= "max-width:65px;"
                                            class="btn-stepper-next"
                                            color="white"
                                            @click="btnNext()"
                                      ><svg style="width:40px;height:40px" viewBox="0 0 24 24">
                                      <path fill="#68b7f6" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                                      </svg>
                                    </v-btn>
                                  
                                </v-flex>
                                
                              </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </section>
                <v-footer class="container-footer" dark flex app>
                    <v-layout justify-center align-center row wrap class="footer">
                        <v-flex class="footer-copyright">
                            Copyright &copy; 2019
                            <a
                                href="http://sicomelectronics.com"
                                target="_blank"
                                style="color: white; text-decoration: none;"
                            >Sicom Electronics International S.A.</a>
                         </v-flex>
                        <v-flex class="footer-nav">
                            <ul class="menu-list">
                                <li class="menu-list-item"><a href="http://sicom.cl/" target="_blank" rel="noopener noreferrer">Home</a></li>
                                <li class="menu-list-item"><a href="#">Términos de Uso</a></li>
                                <li class="menu-list-item"><a href="http://sicom.cl/index.php/contacto/" target="_blank" rel="noopener noreferrer">Contáctenos</a></li>
                                <li class="menu-list-item"><a href="http://sicom.cl/index.php/sobre-nosotros/" target="_blank" rel="noopener noreferrer">Nuestra Compañía</a></li>
                            </ul>
                        </v-flex>
                    </v-layout>
                </v-footer>
            </v-content>
        </template>   
    </v-app>
</template>

<script>
import Axios from 'axios'
import BootstrapVue from 'bootstrap-vue'


export default {
    name: 'App',


    data: () => ({
        
        errors: [],
       radio: "",
       type_contact: [
        'Municipal',
        'Privado',
        'Social',    
      ],
      tab: 0,

      items: [
            {
            //src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
            src:'assets/SimulatorIncidencia.png'
            },
            {
            //src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
            src:'assets/SimulatorDenuncia.png'
            },
            {
            //src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
             src:'assets/SimulatorEncuesta.png'
            },
            {
            //src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
             src:'assets/SimulatorAvisos.png'
            },
            {
            //src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
             src:'assets/SimulatorContacto.png'
            },
        ],

         

        tabItems: [
            'Los usuarios registrados poseen la capacidad de reportar incidencias en tiempo real, mantener un registro total de incidencias y conocer el estado en el que se encuentran. Las incidencias se categorizan, lo que permite a las municipalidades adaptar caracteristicas de la aplicación a las necesidades de sus locatarios, además de contar con un registro de geolocalización, estas poseen un análisis estadístico pensado para aportar a la comunidad.',

            'Alerta a los vecinos y autoridades de las anormalidades que reporten los usuarios, tiene como función principal el generar una red de seguridad entre vecinos. Las denuncias se categorizan según requerimientos municipales, adicionalmente se brindado un registro geográfico, lo que mantiene a usuarios informados, permitiendo evitar contratiempos y resguardar su seguridad.',

            'Pensadas para optimizar el uso de información, tiene como objetivo facilitar a autoridades y entidades municipales el conocer las inquietudes de los ciudadanos, se adapta a requerimientos municipales. Las encuestas son sencillas de responder, formuladas para requerir un mínimo tiempo y mejorar la recepción del usuario.',

            'Mantiene a la ciudadanía actualizada acerca de acontecimientos que incidan en la población. Genera una red contacto personalizada, permite a usuarios recibir información en tiempo real. La aplicacion es capaz de mantiener un registro total de avisos en el móvil.',

            'Canal directo de comunicación municipal, se personaliza de acuerdo a los requerimientos municipales, cuenta con teléfono de contacto, correo y enlaces web.',
        ],



      

         new_contact: {
          name: '',
          email: '',
          phone: '',
          institution:'',
          type_contact:'',
          message:''
          
        },

       
    }),
    computed: {
        getMobileOperatingSystem() {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;

              // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }
    },

     methods: {
        btnNext () {
            if(this.tab >= 4) {
                this.tab= 0
                
            } else {
                this.tab = this.tab + 1
            }
        },
        btnBack () {
            if(this.tab <= 0) {
                this.tab = 4
               

            } else {
                this.tab = this.tab - 1
            }
        }
    } 
}
</script>


<style>

.radio-phone .v-icon
{
    font-size: 7px !important; 
}

.radio-phone .v-input--selection-controls__input {
    margin-right: 0px;
    justify-content: center;
    height: 13px;
    width: 13px; 
}

.btn-stepper-next-phone.v-btn
{
    border-radius: 10px;
    min-width: 15px !important;
    min-height: 15px !important;
    max-width:35px !important;
    max-height: 35px !important;
}

.btn-stepper-back-phone.v-btn
{
    border-radius: 10px;
    min-width: 15px !important;
    min-height: 15px !important;
    max-width:35px !important;
    max-height: 35px !important;
}



.v-window.v-carousel.carousel-phone
{
    /* height:100% !important; */
    width: 39vw !important;
    height: 84vw !important;
    border-radius:5px !important;
}

/* Carrusel pantalla  xs*/


.fill-height
{
    height: 60%;
}

/*titulo */



.v-toolbar__title.img
{
   /* align-content:center !important; */

  vertical-align: middle !important; 

 /*justify-content:center !important; */
 /*align-items:center !important; */

  
}

.-v-toolbar__content{
  padding-top: 100;
  justify-content:center !important; 
 align-items:center !important;

}


/*tamaño icono radio boton */


.v-tabs__item
{

  padding:0px !important;
}


/* */
.v-tabs__item:not(.v-tabs__item--active)
{
 opacity:1 !important;
 color:rgb(124,124,124) !important;
}


.theme--light.v-tabs__bar .v-tabs__div
{
  color: #68b7f6;

}


/* color  de  carrusel  */

.theme--light.v-icon 
{
  color:rgb(104,183,246);
}
/* tamañode de los radio buton */

.v-icon
{
    font-size:24px; 
} 

.v-radio
{
  margin:0px;
}

.v-responsive.v-image.v-carousel__item
{

  height:100% !important;
  width:100% !important;
}


.v-btn.btn-stepper-back
{
  margin-left: 40px;
  margin-bottom:60px; 
  border-radius: 10px;
   min-width: 20px;
   min-height: 60px;

}



.v-btn.btn-stepper-next
{
  margin-right:40px; 
  margin-bottom:60px; 
  border-radius: 10px;
   min-width: 20px;
   min-height: 60px;

}


.a.v-tabs__item
{
    padding-right: 0px !important;
    padding-left: 0px !important;
}

.v-tabs__item .v-tabs__item--active
{
  color: #68b7f6 !important;
}




.p {
    
   font-size:130%;
   
}



/* flat  tabs*/
.theme--light.application
{
    background:white;
}

/* estilos  carrusel*/
.v-image
{
 
 width:100%;
 height:100% !important;   
 margin-bottom:5px !important;  
 margin-top:0px !important;  
} 

.v-window.v-carousel
{

  margin-top:12px; 
  margin-left:185px;

  /*margin-bottom:40px !important;*/

  width:300px !important; 
  height:645px !important;
   

}

.v-carousel /* no sirve el height ni el width  */
{

margin-bottom:25px; 

border-radius: 27px !important;
/*padding-right:20% !important; */
width :400px !important;
height: 700px !important; 

}
/**********************/

.v-carousel__controls
{
   background:white  !important; 
 /*  z-index: 0; */

}

.v-btn .v-btn__content .v-icon{
   color: #68b7f6 !important;
}
/* *************************************/

.container-footer {
    background-color: #0085d9;
}
.footer {
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    padding-left: 60px;
    padding-right: 60px;
    background-color: #0085d9;
}
.footer-nav ul {
    float: right;
    padding-left: 0px;
}
.footer-nav ul li{
    display: inline-block;
    padding-left: 10px;
}
.footer-nav ul li a {
    text-decoration: none;
   font-size: 13px;
   font-family: 'Roboto', sans-serif;
   font-weight: 300;
   font-style: normal;
   line-height: 22px;
    color: #FFFFFF;
}

@media (max-width: 768px){
    .footer-nav ul {
        float: none;
        text-align: center;
    }
    .footer-copyright {
        float: none;
        text-align: center;
        color:#ffffff; 
    }
}
</style>
